// extracted by mini-css-extract-plugin
export var iconSection = "iconSection-module--iconSection--Sdi0g";
export var iconTitle = "iconSection-module--iconTitle--QV4oF";
export var faStar = "iconSection-module--faStar--OkLy8";
export var iconDescription = "iconSection-module--iconDescription--x9bWv";
export var darkBackground = "iconSection-module--darkBackground--N0rjT";
export var mobileFirstSection = "iconSection-module--mobileFirstSection--3H5d6";
export var starIcon = "iconSection-module--starIcon--eoRwz";